import * as React from 'react';

const useCancellationReason = ()=>{
    const [selectedCancellationType, setSelectedCancellationType] = React.useState('');
    const handleFormChange = React.useCallback((formState)=>{
        var ref;
        const typeField = (ref = formState.formState) === null || ref === void 0 ? void 0 : ref.cancellationType;
        const cancellationType = (typeField === null || typeField === void 0 ? void 0 : typeField.value) || '';
        setSelectedCancellationType(cancellationType);
    }, []);
    const getReasonFromForm = React.useCallback((formState)=>{
        const typeField = formState === null || formState === void 0 ? void 0 : formState.cancellationType;
        const cancellationType = typeField === null || typeField === void 0 ? void 0 : typeField.value;
        if (cancellationType === 'ORDINARY') {
            var ref;
            return formState === null || formState === void 0 ? void 0 : (ref = formState.reasonOrdinary) === null || ref === void 0 ? void 0 : ref.value;
        }
        if (cancellationType === 'EXTRAORDINARY') {
            var ref1;
            return formState === null || formState === void 0 ? void 0 : (ref1 = formState.reasonExtraordinary) === null || ref1 === void 0 ? void 0 : ref1.value;
        }
        return undefined;
    }, []);
    return {
        selectedCancellationType,
        handleFormChange,
        getReasonFromForm
    };
};

export { useCancellationReason };
//# sourceMappingURL=use-cancellation-reason.js.map
